export interface SharedMessageModel {
    messageType: string;
    data: any;
}

export enum SharedMessageType {
    Dictionary = 'Dictionary'
}
